import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const EneoDetails = () => <OperatorRequestDetails />;

export default EneoDetails;
